import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { IPagination } from '@shared/models/paginator';
import { PageUrlPipe } from '@shared/pipes';

@Component({
  selector: 'app-shared-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit {
  @Input() pagination?: IPagination;
  @Input() disabled = false;

  protected currentPage: number =
    parseInt(this.route.snapshot.params['page']) || 1;
  protected pages: number[] = [];
  protected pagesToShow: number[] = [];

  protected showPreviousDots = false;
  protected showNextDots = false;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      if (this.pages.length > 0) return;
      const page = params.get('page');
      this.currentPage = page ? parseInt(page) : 1;
      this.handlePageChange();
    });
  }

  verifyIfPageExists(): void {
    if (!this.pagination) return;
    if (this.pages.length > 0 && this.currentPage > this.pages.length) {
      const lastPage = Math.ceil(this.pagination.count / this.pagination.limit);
      const pageUrl = new PageUrlPipe(this.route).transform(lastPage);
      this.router.navigate(pageUrl);
    }
  }

  handlePageChange(): void {
    if (!this.pagination) return;

    const { count, limit } = this.pagination;
    const pageCount = Math.ceil(count / limit);
    this.pages = Array.from({ length: pageCount }, (_, i) => i + 1);
    this.verifyIfPageExists();

    // - Set an array of 5 pages
    // - the total pages is less than 5, show all pages
    // - If the current page is less than 3, show the first 5 pages
    // - If the current page is greater than the total pages minus 2, show the last 5 pages
    // - Otherwise, show the current page and the 2 pages before and after it
    const pagesToShow = Array.from({ length: 5 }, (_, i) => i + 1);
    if (pageCount < 5) {
      this.pagesToShow = this.pages;
    } else if (this.currentPage < 3) {
      this.pagesToShow = pagesToShow;
    } else if (this.currentPage > pageCount - 2) {
      this.pagesToShow = pagesToShow.map((page) => pageCount - 5 + page);
    } else {
      this.pagesToShow = pagesToShow.map((page) => this.currentPage - 3 + page);
    }

    // Show dots if the first or last page is not in the array of pages to show
    this.showPreviousDots = this.pagesToShow[0] !== 1;
    this.showNextDots =
      this.pagesToShow[this.pagesToShow.length - 1] !== pageCount;
  }
}
